import { queryOptions } from '@tanstack/react-query'

import { fetchDashboardInfo, fetchExerciseStats } from '../dal/activity-dal'
import { queryKeys } from './query-keys'

export const exerciseStatsQueryOptions = queryOptions({
  queryKey: queryKeys.activities.stats(),
  queryFn: fetchExerciseStats,
  staleTime: 5 * 60 * 1000,
})

export const dashboardInfoQueryOptions = (yearWeek: string) =>
  queryOptions({
    queryKey: queryKeys.exercise.dashboardInfo(yearWeek),
    queryFn: () => fetchDashboardInfo(yearWeek),
    staleTime: 5 * 60 * 1000,
  })
